import Multiselect from "multiselect-react-dropdown";
import React from "react";
import { useState, useEffect } from "react";
import DownloadReport from "../DownloadReport/DownloadReport";
import { useDispatch, useSelector } from "react-redux";
import { selectFilters, setFilters } from "../../redux/slices/filterSlice";

const Filter = ({
  noRecords,
  applyFilter,
  options,
  handleDownloadSuccess,
  handleDownloadError,
  handleDownloadRequestError,
  downloadParams,
}) => {


  const dispatch = useDispatch();
  const filtersFromStore = useSelector(selectFilters);
  
  const SUMMARY_DATA_PROPERTIES = {
    lab: "diamond#cert",
    shape: "diamond#shape",
    color: "diamond#color",
    clarity: "diamond#clarity",
    carats: "gem#carats",
    milky: "diamond#milky",
    shade: "diamond#shade",
    make: "diamond#make",
    fluor: "diamond#fluor",
    bic: "diamond#black_in_center",
    bis: "diamond#black_in_side",
    wis: "diamond#white_in_side",
    wic: "diamond#white_in_center",
  };

  const [filters, setFiltersLocal] = useState(() => JSON.parse(JSON.stringify(filtersFromStore || {})));
  
  useEffect(() => {
    setFiltersLocal(JSON.parse(JSON.stringify(filtersFromStore || {})));
  }, [filtersFromStore]);

  const onSelect = (selectedList, removedItem, className) => {
    const attrName = SUMMARY_DATA_PROPERTIES[className];
    if (!attrName) return;

    // Create a new filters object
    const updatedFilters = { ...filters };

    if (selectedList?.length) {
      const filterValues = selectedList.map(option => {
        if (attrName === "gem#carats") {
          const [from, to] = option.key.split("-");
          return { from, to };
        }
        return option.key;
      });
    //  console.log("filterValues", filterValues)
      // Handle both color/clarity and other fields consistently
      if (attrName === "diamond#color" || attrName === "diamond#clarity") {
        updatedFilters[attrName] = filterValues.flat(); // Wrap in array to maintain structure
      } else {
        updatedFilters[attrName] = filterValues;
      }
    } else {
      // Remove the key if no values selected
      delete updatedFilters[attrName];
    }

    setFiltersLocal(updatedFilters);
  };

  const handleApplyFilter = () => {
    // Prepare filters for Redux and API
    const preparedFilters = Object.keys(filters).reduce((acc, key) => {
      if (filters[key]?.length) {
        if (key === "diamond#color" || key === "diamond#clarity") {
          // Ensure color and clarity maintain their structure
          acc[key] = filters[key].flat();
        } else {
          acc[key] = filters[key];
        }
      }
      return acc;
    }, {});

    // Update Redux store
    dispatch(setFilters(preparedFilters));
    
    // Call parent's apply filter
    applyFilter(preparedFilters);
  };


const renderMultiselect = (key, optionList, isNoRecords) => {
  const attrName = SUMMARY_DATA_PROPERTIES[key];
  const selectedValues = filters[attrName]
  ?.flat()
  .map((value) => {
    return optionList.find((option) => {
      if (attrName === "diamond#color" || attrName === "diamond#clarity") {
        // Color keys are arrays, check if any match
        return Array.isArray(option.key) ? option.key.includes(value) : option.key === value;
      } 
      // if (attrName === "diamond#clarity") {
      //   // Clarity should be matched by name, not key
      //   return Array.isArray(option.key) && option.key.some((val) => value.includes(val));
        
      // } 
      if (attrName === "gem#carats") {
        // Convert object `{ from, to }` into "from-to" string for comparison
        return option.key === `${value.from}-${value.to}`;
      }
      return option.key === value;
    });
    
  })
  .filter(Boolean) || [];

  const uniqueSelectedValues = selectedValues.reduce((acc, option) => {
    if (option && !acc.some((selected) => selected.name === option.name)) {
      acc.push(option);
    }
    return acc;
  }, []);


  return (
      <div className="col-sm-3" style={{ padding: "10px" }} key={key}>
          <Multiselect
              optionLabel={"Select " + key}
              onSelect={(selectedList) => onSelect(selectedList, null, key)}
              onRemove={(removedList) => onSelect(removedList, null, key)}
              className={key}
              options={optionList}
              displayValue="name"
              placeholder={"Select " + key}
              selectedValues={uniqueSelectedValues}
          />
      </div>
  );
};

  return (
    <>
      <div className="row justify-content-start border-secondary" style={{ margin: "10px" }}>
            {Object.entries(options || {}).map(([key, optionList]) =>
                renderMultiselect(key, optionList)
            )}
      </div>
      <div className="col-lg-12" style={{}}>
        <div
          className="row"
          style={{
            justifyContent: "end",
          }}
        >
          <div style={{ marginBottom: "8px", width: "fit-content" }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleApplyFilter}
            >
              <i className=" bi bi-sliders me-1"></i> Apply Filters
            </button>
          </div>

          {/* <DownloadReport
            handleDownloadSuccess={handleDownloadSuccess}
            handleDownloadError={handleDownloadError}
            handleDownloadRequestError={handleDownloadRequestError}
            captureReportDownloadParams={downloadParams}
          /> */}
        </div>
      </div>
    </>
  );
};

export default Filter;
